var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorcycleDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "motorcycle",
    className: "svg-inline--fa fa-motorcycle fa-w-20",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fa-secondary",
    fill: "#fff",
    d: "M252 352a127.94 127.94 0 1 1-87.42-154.7l-24 43.69A80 80 0 1 0 201.3 352zm260-160a127.81 127.81 0 0 0-41.46 6.87l25.61 42.71a80.22 80.22 0 1 1-42 23.26l-25.26-42.17A128 128 0 1 0 512 192z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa-primary",
    fill: "#fff",
    d: "M175.83 176.8c-9.1-13.9-23.3-24.8-47.8-24.8H72a24 24 0 0 1-24-23.5C47.73 115 59 104 72.53 104H128c55 0 82.2 16.9 99.9 40h153.7l-19.2-32H296a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h80a24.16 24.16 0 0 1 20.6 11.6l22.8 38 37.5-41.7a24 24 0 0 1 17.8-7.9H520a23.94 23.94 0 0 1 24 24v32a23.94 23.94 0 0 1-24 24h-82.4l107.1 178.6a16.07 16.07 0 0 1-5.5 22l-13.7 8.2a16.07 16.07 0 0 1-22-5.5l-87.1-145.4a151.48 151.48 0 0 0-56.2 125 24 24 0 0 1-24 25.1H120a24 24 0 0 1-21-35.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycleDuotone);
export default __webpack_public_path__ + "static/media/motorcycle-duotone.3cb899eddf560bf69d5699cd73c285a7.svg";
export { ForwardRef as ReactComponent };